import {
  del,
  file,
  get, post, put, putJSON, remove,
} from './http-service'

export const loginApi = (data) => post('/api/auth/sign-in', data)

export const logoutApi = () => post('/api/auth/sign-out', '', true)

export const loginWithCodeApi = (data) => post('/api/auth/email', data)

export const getVisitApi = (params) => get('/api/visit', true, params)

export const visitDetailsApi = (id) => get(`/api/visit/${id}`, true)

export const closeVisitApi = (id) => put(`/api/visit/${id}`, id, true)

export const patientDetailsApi = (id) => get(`/api/patient/${id}`, true)

export const userListApi = (params) => get('/api/user/all', true, params)

export const queryStringUser = "USER"

export const fetchUsers = async (doctors, visitorId, page = 0, size = 20, search = '', sort = '') => {
  const response = await userListApi({ withPatients: false, withVisits: false, page, size, search, sort: sort ? sort : null })
  if (response.status === 200) {
    const users = response.data.content || []
    const userAndDoctors = users.map(user => {
      const doctor = doctors.find(doc => {
        return doc.id === +(user.profile.data.doctor)
      }) || { id: -1 }
      return {
        ...user,
        doctor: doctor,
        order: doctor.id === visitorId ? 0 : 1
      }
    })
    const result = sort ? userAndDoctors : userAndDoctors.sort((a, b) => a.order > b.order ? 1 : -1)
    return { content: result, totalElements: response.data.totalElements }
  } else {
    return { content: [], totalElements: 0 }
  }
}

export const addMedia = (data) => post('/api/media', data, true)

export const getMediaDetailsApi = (id) => get(`/api/media/${id}`, true)

export const getMediaAnalyzeApi = (id) => get(`/api/media/analyze/${id}`, true)

export const predict = (id) => get(`/api/prediction/${id}`, true)

export const putMediaCommentApi = (id, data) => put(`/api/media/comment/${id}`, data, true)

export const getMediaApi = (id) => file(`/api/media/${id}/file`, true)

export const getExamTypeApi = (id) => get(`/api/exam-type/${id}`, true)

export const getExamApi = (id) => get(`/api/exam/${id}`, true)

export const putExamCommentApi = (id, data) => put(`/api/exam/comment/${id}`, data, true)

export const getExams = () => get('/api/exam', true)

export const getAllExams = (page = 0, size = 20, state = '', supervisor, byDoctor,
  byType, profileQualityKey, profileQualityValue, fromDate, toDate, aiDeclined) => get('/api/exam/all', true,
    {
      page, size, state, supervisor,
      byType, byDoctor, profileQualityKey, profileQualityValue, fromDate, toDate, aiDeclined, sort: 'createdAt,desc'
    })

export const addExam = (data) => post('/api/exam', data, true)

export const addExamData = (data) => post('/api/exam-data', data, true)

export const getExamsByPatient = (patientId) => get(`/api/exam?byPatient=${patientId}`, true)

export const editProfileApi = (id, data) => put(`/api/profile/${id}?merge=true&withDate=true`, data, true)

export const editProfileWithoutMergeApi = (id, data) => put(`/api/profile/${id}?merge=false&withDate=true`, data, true)

export const openNewVisitApi = (data) => post(`/api/visit`, data, true)

export const getPatientListApi = () => get(`/api/patient`, true)

export const addPatient = (userId, data) => post(`/api/patient?userId=${userId}`, data, true)

export const getExamTypeListApi = () => get('/api/exam-type', true)

export const getProvisionApi = () => get(`/api/provision?t=${new Date().getTime()}`, true)

export const getUser = (id) => get(`/api/user/${id}`, true)

export const getUserWithPatients = (id) => get(`/api/user/${id}?withPatients=true`, true)

export const deleteUserApi = (id) => remove(`/api/user/${id}`, true)

export const closeExamApi = (id) => remove(`/api/exam/${id}/close`, true)

export const acceptPointApi = (id) => put(`/api/exam-data/${id}/accept`, id, true)

export const addUserApi = (data) => post(`/api/user`, data, true)

export const addUserWebPushSubscription = (id, data) => put(`/api/user/${id}/web-push`, data, true)

export const deletePatientApi = (id) => remove(`/api/patient/${id}`, true)

export const postApiDocument = (data) => post('/api/document', data, true)

export const editUserApi = (id, data) => put(`/api/user/${id}`, data, true)

export const updateUserRoles = (id, /** @type {string[]} */ roles) => {
  const params = roles.map(role => `value=${role}`)
  return put(`/api/user/${id}/roles?${params.join('&')}`, null, true)
}

export const getDoctorsList = () => get(`/api/doctor`, true)

export const editDoctor = (id, data) => put(`/api/doctor/${id}`, data, true)

export const getDoctorDetails = (id) => get(`/api/doctor/${id}`, true)
/**
 * @typedef { object } Group
 * @property { number } id
 * @property { string } name
 * @property { string } description
 */
/**
 *
 * @returns { Promise<import('axios').AxiosResponse<Group[]>> } groups list
 */
export const getDoctorsGroupsList = () => get(`/api/doctor/groups`, true)
/**
 * @param { Group } data group data
 * @returns { Promise<import('axios').AxiosResponse<Group>> } created group
 */
export const addGroup = (data) => post(`/api/doctor/groups`, data, true)
/**
 * @param { number } id group id
 * @param { Group } data group data
 * @returns { Promise<import('axios').AxiosResponse<Group>> } edited group
 */
export const editGroup = (id, data) => put(`/api/doctor/groups/${id}`, data, true)
/**
 * @param { number } id group id
 * @returns { Promise<import('axios').AxiosResponse> } deletion status
 */
export const deleteGroup = (id) => { return del(`/api/doctor/groups/${id}`, true) }

export const getDiariesApi = (visitId) => get(`/api/diary?visitId=${visitId}`, true)

export const addDocumentApi = (data) => post(`/api/document`, data, true)

export const editPatientApi = (id, data) => put(`/api/patient/${id}`, data, true)

export const getQuestionnaireList = (questionType, examType) => {
  const urlParams = new URLSearchParams()
  urlParams.set("t", +new Date())
  urlParams.set("type", questionType)
  if (examType) {
    urlParams.set("examType", examType)
  }
  return get(`/api/questionnaire/quest?${urlParams.toString()}`, true)
}

export const getQuestionnaireItem = (questionId) => get(`/api/questionnaire/quest/${questionId}`, true)

export const addQuestionnaireApi = (data) => post(`/api/questionnaire/quest`, data, true)

export const updateQuestionnaireApi = (id, data) => put(`/api/questionnaire/quest/${id}`, data, true)

export const deleteQuestionnaireApi = (id) => remove(`/api/questionnaire/quest/${id}`, true)

export const deleteDoctorApi = (id) => remove(`/api/doctor/${id}`, true)

export const deleteMediaApi = (id) => remove(`/api/media/${id}`, true)

export const getExamListByVisitApi = (visitId) => get(`/api/exam?byVisit=${visitId}`, true)

export const documentTypeApi = () => get(`/api/document-type`, true)

export const getListOfProfiles = (patientId) => get(`/api/profile?byPatient=${patientId}&split=true&type=VISIT`, true)

export const getDocumentList = (patientId) => get(`/api/document?byPatient=${patientId}`, true)

export const getDocumentListFiltered = (patientId, from, to) => get(`/api/document?byPatient=${patientId}&from=${from}&to=${to}`, true)

export const getVaccinationListApi = (patientId) => get(`/api/vaccination?patientId=${patientId}`, true)

export const addVaccineApi = (data) => post(`/api/vaccination`, data, true)

export const deleteVaccineApi = (id) => remove(`/api/vaccination/${id}`, true)

export const getVaccineDetailsApi = (id) => get(`/api/vaccination/${id}`, true)

export const editVaccineApi = (id, data) => put(`/api/vaccination/${id}`, data, true)

export const eulaAccept = () => post(`/api/auth/accept`, null, true)

export const isReadClaim = (id) => put(`/api/questionnaire/quest/isread/${id}`, null, true)

export const uploadMediaFile = (id, file, params) => {
  const formData = new FormData()
  formData.append("file", file)
  if (params) {
    for (var key in params) {
      formData.append(key, params[key])
    }
  }
  return post(`/api/media/${id}`, formData, true)
}

export const updateDecision = (data)=> post('/api/doctor/decision', data, true)

export const verifyDecision = (id, verified) => putJSON(`/api/doctor/verify_decision/${id}`, verified, true)

export const declineDecision = (id, declined) => putJSON(`/api/doctor/decline_decision/${id}`, declined, true)

export const getOperationalReport = (range) => file(`/api/reports/operational?startDate=${range[0].unix()}&endDate=${range[1].unix()}`)

export const getClinicReport = (id, range) => file(`/api/reports/clinic?groupId=${id}&startDate=${range[0].unix()}&endDate=${range[1].unix()}`)

export const getAIDecisionReport = () => get('/api/reports/validated_decisions', true)

export const updateUserGroup = (inviteCode) => put(`/api/user?inviteCode=${inviteCode}`, null, true)

export const mergePatients = (data) => post('/api/patient/merge', data, true)

export const addExamType = (data) => post('/api/exam-type', data, true)

export const updateExamType = (id, data) => put(`/api/exam-type/${id}`, data, true)

export const addExamTypePoint = (data) => post('/api/exam-point-type', data, true)

export const updatePointTypeAsset = (id, data) => put(`/api/exam-point-type/${id}`, data, true)

// Exam Information APIs
export const getExamInfoList = () => get('/api/exam-info', true)

export const getExamInfo = (id) => get(`/api/exam-info/${id}`, true)

export const addExamInfo = (data) => post('/api/exam-info', data, true)

export const updateExamInfo = (id, data) => put(`/api/exam-info/${id}`, data, true)

export const deleteExamInfo = (id) => remove(`/api/exam-info/${id}`, true)

export const getExamInfoPageListByExamInfo = (examInfoId) => get(`/api/exam-info/${examInfoId}/pages`, true)

export const addExamInfoPage = (data) => post('/api/exam-info-page', data, true)

export const updateExamInfoPage = (id, data) => put(`/api/exam-info-page/${id}`, data, true)

export const deleteExamInfoPage = (id) => remove(`/api/exam-info-page/${id}`, true)

// Filter Preset APIs
export const getFilterPresets = () => get('/api/filter-presets', true)

export const getFilterPreset = (id) => get(`/api/filter-presets/${id}`, true)

export const addFilterPreset = (data) => post('/api/filter-presets', data, true)

export const updateFilterPreset = (id, data) => put(`/api/filter-presets/${id}`, data, true)

export const deleteFilterPreset = (id) => remove(`/api/filter-presets/${id}`, true)

